"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnownCreateElementDataIndex = void 0;
/**
 * Index of known CreateElementData used by createElement function
 */
var KnownCreateElementDataIndex;
(function (KnownCreateElementDataIndex) {
    /**
     * Set a none value to help createElement function ignore falsy value
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["None"] = 0] = "None";
    /**
     * An empty line without format
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["EmptyLine"] = 1] = "EmptyLine";
    /**
     * Wrapper for blockquote
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["BlockquoteWrapper"] = 2] = "BlockquoteWrapper";
    /**
     * Temp DIV for copy/paste
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["CopyPasteTempDiv"] = 3] = "CopyPasteTempDiv";
    /**
     * ListItem with block style
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["BlockListItem"] = 4] = "BlockListItem";
    /**
     * Wrapper element for context menu
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["ContextMenuWrapper"] = 5] = "ContextMenuWrapper";
    /**
     * Wrapper element for image edit
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["ImageEditWrapper"] = 6] = "ImageEditWrapper";
    /**
     * @deprecated
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["TableHorizontalResizer"] = 7] = "TableHorizontalResizer";
    /**
     * @deprecated
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["TableVerticalResizer"] = 8] = "TableVerticalResizer";
    /**
     * @deprecated
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["TableResizerLTR"] = 9] = "TableResizerLTR";
    /**
     * @deprecated
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["TableResizerRTL"] = 10] = "TableResizerRTL";
    /**
     * @deprecated
     */
    KnownCreateElementDataIndex[KnownCreateElementDataIndex["TableSelector"] = 11] = "TableSelector";
})(KnownCreateElementDataIndex = exports.KnownCreateElementDataIndex || (exports.KnownCreateElementDataIndex = {}));
//# sourceMappingURL=KnownCreateElementDataIndex.js.map